import { ViewContract } from './view-contract';

export class ViewContractDashboard extends ViewContract {
	public ptc: number;
	public indicativeRate: number;
	public displayRate: number;
	public isPurchasingLayerContract: boolean;
	public enterpriseId: number;
	public enterpriseName: string;
}
